export const phoneTypes = [
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Landline', value: 'Landline' },
]

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

/** Referral value that marks a lead as a repeat, shared with the API. */
export const REPEAT_REFERRAL = 'Repeat Customer'

/**
 * Next value for the "Repeat customer" checkbox after the by-email lookup
 * resolves, or `undefined` to leave it untouched.
 *
 * - Found an existing customer  -> tick it.
 * - Not found, rep already touched the box or chose the repeat referral -> leave it.
 * - Not found, untouched        -> untick (the lookup is the only signal).
 */
export const resolveRepeatAfterEmailLookup = ({
  found,
  repeatTouched,
  referredBy,
}: {
  found: boolean
  repeatTouched: boolean
  referredBy?: string | null
}): boolean | undefined => {
  if (found) return true
  if (repeatTouched || referredBy === REPEAT_REFERRAL) return undefined
  return false
}
